var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-col",
    {
      class: { "insetx-16": _vm.$media.l, "insetx-4": _vm.$media.s },
      attrs: { id: "search-res" },
    },
    [
      _vm.total > 0
        ? _c(
            "div",
            {
              staticClass: "flex-flex",
              class: { "after-16": _vm.ids.length === 0 },
            },
            [
              _c(
                "ib-row",
                [
                  _c("ib-col", [
                    _c(
                      "div",
                      {
                        staticClass: "before-16",
                        class: {
                          "outsetx-4": _vm.$media.xl,
                          "float-left": _vm.$media.xl,
                          "text-center": !_vm.$media.xl,
                          "after-8": !_vm.$media.xl,
                        },
                      },
                      [
                        _vm.total > 0
                          ? _c("p", [
                              _vm._v(_vm._s(_vm.$t("showing"))),
                              _vm.curResults.length <= _vm.$num.int(_vm.total)
                                ? _c("span", { staticClass: "outsetx-4" }, [
                                    _vm._v(
                                      _vm._s(_vm.curResults.length) +
                                        " " +
                                        _vm._s(_vm.$t("of")) +
                                        " " +
                                        _vm._s(_vm.$num.int(_vm.total))
                                    ),
                                  ])
                                : _c("span", { staticClass: "outsetx-4" }, [
                                    _vm._v(
                                      _vm._s(_vm.curResults.length) +
                                        " " +
                                        _vm._s(_vm.$t("of")) +
                                        " " +
                                        _vm._s(_vm.$num.int(_vm.total))
                                    ),
                                  ]),
                              _vm.status === "loading"
                                ? _c(
                                    "span",
                                    [
                                      _c("ib-progress-circular", {
                                        staticClass: "_ga_total_spinner",
                                        attrs: {
                                          width: "20px",
                                          height: "20px",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "ib-row",
        [
          _c(
            "ib-col",
            {
              staticClass: "flex",
              staticStyle: { "max-height": "65vh" },
              attrs: { id: "scroll" },
            },
            [
              _c("SearchTerm"),
              _c(
                "ib-table-basic",
                {
                  staticClass: "fs7 fg70 shrink fin-table",
                  staticStyle: {
                    border: "1px solid rgba(0,0,0,0.15)",
                    "overscroll-behavior": "contain",
                  },
                  attrs: {
                    data: _vm.curResults,
                    row: "",
                    colborder: "",
                    rowstripe: "",
                    spacing: "huge",
                    id: "_ga-scroll-table",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "body",
                      fn: function (res) {
                        return [
                          !_vm.$media.l
                            ? _c("td", { staticClass: "padding-zero" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "info results",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showResultModal(res)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { viewBox: "0 0 13 13" } },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M6.5 0A6.5 6.5 0 1013 6.5 6.5 6.5 0 006.5 0z",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M6.5 2.543a.848.848 0 10.848.848.848.848 0 00-.848-.848zM5.37 5.37v.565h.565v3.674H5.37v.565h2.26v-.565h-.565V5.37z",
                                            fill: "#fff",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "td",
                            {
                              staticClass: "row_tracker",
                              attrs: {
                                "data-conid": res["conid"],
                                title: res["name"],
                              },
                              on: { click: _vm.getMoreInfo },
                            },
                            [_vm._v(_vm._s(_vm.formatComp(res["name"])))]
                          ),
                          _c(
                            "td",
                            {
                              attrs: { title: res["ticker"] },
                              on: {
                                click: function ($event) {
                                  return _vm.getMoreDetails(
                                    res["company"],
                                    res["conid"]
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "fg-accent" }, [
                                _vm._v(_vm._s(res["ticker"])),
                              ]),
                            ]
                          ),
                          _c("td", {
                            attrs: { title: res["country"] },
                            domProps: { textContent: _vm._s(res["country"]) },
                            on: { click: _vm.getMoreInfo },
                          }),
                          _c("td", {
                            attrs: { title: res["sector"] },
                            domProps: { textContent: _vm._s(res["sector"]) },
                            on: { click: _vm.getMoreInfo },
                          }),
                          _c(
                            "td",
                            {
                              attrs: { title: res["conv_price"] },
                              on: { click: _vm.getMoreInfo },
                            },
                            [
                              !res["conv_price"]
                                ? _c("div", { staticClass: "spin" })
                                : _c(
                                    "span",
                                    { staticClass: "text-right weighted" },
                                    [_vm._v(_vm._s(res["conv_price"]))]
                                  ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              on: { click: _vm.getMoreInfo },
                            },
                            [_vm._v(_vm._s(_vm.getFormat(res["mkt_nav"])))]
                          ),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.getGrowth(res["eps_1y"]))),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.getYield(res["div_yield"]))),
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              on: { click: _vm.getMoreInfo },
                            },
                            [_vm._v(_vm._s(_vm.getFixed(res["pe"])))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              on: { click: _vm.getMoreInfo },
                            },
                            [_vm._v(_vm._s(_vm.getRatio(res["peg"])))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              on: { click: _vm.getMoreInfo },
                            },
                            [_vm._v(_vm._s(_vm.getFormat(res["ev"])))]
                          ),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.setExchRev(res["rev"]))),
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              on: { click: _vm.getMoreInfo },
                            },
                            [_vm._v(_vm._s(_vm.setExchNI(res["earnings"])))]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  !_vm.$media.l
                    ? _c(
                        "ib-table-col",
                        { attrs: { width: "3ch", sticky: "" } },
                        [
                          _c("div", { staticClass: "border-bottom" }),
                          _c("div", [
                            _c("span", { staticClass: "weighted text-right" }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c("ib-table-col", { attrs: { width: "14ch", sticky: "" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("name")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { title: _vm.$t("company_name") } },
                          [_vm._v(_vm._s(_vm.$t("company_name")))]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "name" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("name", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "name" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("name", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c(
                          "span",
                          { attrs: { title: _vm.$t("weighted_average") } },
                          [_vm._v(_vm._s(_vm.$t("weighted_average")))]
                        ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "8ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("ticker")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("ticker") } }, [
                          _vm._v(_vm._s(_vm.$t("ticker"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "ticker" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("ticker", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "ticker" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("ticker", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c("span", { staticClass: "weighted text-right" }, [
                          _vm._v("-"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "10ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("country")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("country") } }, [
                          _vm._v(_vm._s(_vm.$t("country"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "country" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("country", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "country" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("country", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c("span", { staticClass: "weighted text-right" }, [
                          _vm._v("-"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "9ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("sector")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("sector") } }, [
                          _vm._v(_vm._s(_vm.$t("sector"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "sector" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("sector", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "sector" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("sector", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c("span", { staticClass: "weighted text-right" }, [
                          _vm._v("-"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "8ch" } }, [
                    _c(
                      "div",
                      { class: { "border-bottom": _vm.ids.length === 0 } },
                      [
                        _c("span", { attrs: { title: _vm.$t("price") } }, [
                          _vm._v(_vm._s(_vm.$t("price")) + "*"),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c("span", { staticClass: "weighted text-right" }, [
                          _vm._v("-"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "10ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("mkt_nav")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("mkt_cap") } }, [
                          _vm._v(
                            _vm._s(_vm.$t("mkt_cap") + "/" + _vm.$t("nav"))
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "mkt_nav" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("mkt_nav", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "mkt_nav" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("mkt_nav", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fg-70 fg-primary text-right weighted",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getFormat(
                                  _vm.averagesResponse.res[0].mkt_nav
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "12ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("eps")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("eps") } }, [
                          _vm._v(_vm._s(_vm.$t("eps")) + " %"),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "eps" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("eps", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "eps" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("eps", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fg-70 fg-primary text-right weighted",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getGrowth(_vm.averagesResponse.res[0].eps)
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "10ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("div")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("div") } }, [
                          _vm._v(_vm._s(_vm.$t("div")) + " %"),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "div" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("div", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "div" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("div", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        parseFloat(-1) > 0
                          ? _c("span", {
                              staticClass:
                                "fg-70 fg-primary text-right weighted",
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "fg-70 fg-primary text-right weighted",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getYield(
                                      _vm.averagesResponse.res[0].div
                                    )
                                  )
                                ),
                              ]
                            ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "7ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("pe")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("pe") } }, [
                          _vm._v(_vm._s(_vm.$t("pe"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "pe" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("pe", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "pe" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("pe", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        parseFloat(-1) > 0
                          ? _c("span", {
                              staticClass:
                                "fg-70 fg-primary text-right weighted",
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "fg-70 fg-primary text-right weighted",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getFixed(_vm.averagesResponse.res[0].pe)
                                  )
                                ),
                              ]
                            ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "7ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("peg")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("peg") } }, [
                          _vm._v(_vm._s(_vm.$t("peg"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "peg" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("peg", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "peg" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("peg", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        parseFloat(-1) > 0
                          ? _c("span", {
                              staticClass:
                                "fg-70 fg-primary text-right weighted",
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "fg-70 fg-primary text-right weighted",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getRatio(
                                      _vm.averagesResponse.res[0].peg
                                    )
                                  )
                                ),
                              ]
                            ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "8ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("ev")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("ev") } }, [
                          _vm._v(_vm._s(_vm.$t("ev"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "ev" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("ev", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "ev" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("ev", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fg-70 fg-primary text-right weighted",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getFormat(_vm.averagesResponse.res[0].ev)
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "7ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("rev")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("rev") } }, [
                          _vm._v(_vm._s(_vm.$t("rev"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "rev" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("rev", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "rev" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("rev", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "fg-70 fg-primary text-right weighted",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.setExchRev(_vm.averagesResponse.res[0].rev)
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("ib-table-col", { attrs: { width: "10ch" } }, [
                    _c(
                      "div",
                      {
                        class: { "border-bottom": _vm.ids.length === 0 },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.sortResults("earnings")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { title: _vm.$t("earnings") } }, [
                          _vm._v(_vm._s(_vm.$t("earnings"))),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ids.length === 0,
                                expression: "ids.length === 0",
                              },
                            ],
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "up",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "earnings" &&
                                    _vm.sort.dir === "asc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("earnings", "asc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M25 13L4 35h42z" },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "down",
                                class: {
                                  "active-sort":
                                    _vm.sort.type === "earnings" &&
                                    _vm.sort.dir === "desc",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sortResults("earnings", "desc")
                                  },
                                },
                              },
                              [
                                _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                  _c("path", {
                                    attrs: { d: "M4 17l21 22 21-22z" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ids.length === 0,
                            expression: "ids.length === 0",
                          },
                        ],
                      },
                      [
                        parseFloat(-1) > 0
                          ? _c("span", {
                              staticClass:
                                "fg-70 fg-primary text-right weighted",
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "fg-70 fg-primary text-right weighted",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.setExchNI(
                                      _vm.averagesResponse.res[0].earnings
                                    )
                                  )
                                ),
                              ]
                            ),
                      ]
                    ),
                  ]),
                  _c(
                    "template",
                    { slot: "foot" },
                    [
                      _vm.ids.length === 0 &&
                      this.curResults.length > 0 &&
                      this.total - this.curResults.length > 1
                        ? _c("LoadMore", { on: { intersecting: _vm.loadMore } })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.picked !== null
        ? _c("InfoModal", {
            ref: "allInfoModal",
            attrs: { picked: _vm.picked, type: _vm.searchBy },
          })
        : _vm._e(),
      _c("DetailsModal", { ref: "detailInfoFour" }),
      _c(
        "ib-dialog",
        {
          ref: "modal",
          staticClass: "login-dialog",
          attrs: { autoclose: true },
          model: {
            value: _vm.showLoginScreen,
            callback: function ($$v) {
              _vm.showLoginScreen = $$v
            },
            expression: "showLoginScreen",
          },
        },
        [
          _c("div", { staticClass: "inner-modal" }, [
            _c("div", { staticClass: "add-info flex-fixed top" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("login")))]),
              _c("a", { on: { click: _vm.closeModal } }, [
                _c("span", { staticClass: "fg" }, [
                  _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                    _c("path", {
                      attrs: {
                        d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                        fill: "#fff",
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _c("h5", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("login_to_portal"))),
              ]),
              _c(
                "p",
                { staticClass: "text-center" },
                [
                  _c(
                    "ib-button",
                    {
                      staticClass: "bg-accent _btn act",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.addFilters.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("have_existing_account")))]
                  ),
                ],
                1
              ),
              _c("br"),
              _c("h5", { staticClass: "text-center" }, [
                _vm._v(
                  _vm._s(_vm.$t("no_account")) +
                    " " +
                    _vm._s(_vm.$t("open_one"))
                ),
              ]),
              _c("p", { staticClass: "text-center after-16" }, [
                _c(
                  "a",
                  {
                    staticClass: "bg-accent _btn act",
                    attrs: {
                      href: "https://www.interactivebrokers.com/en/index.php?f=4695",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("open_ib_account")))]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }